// defined in api-url.js
declare var defaultApiUrl: string;

export const environment = {
    production: false,
    gatewayApiUrl: defaultApiUrl
};